import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from './pages/EditPage';
import {useVerifiedPermissions} from "@flexinet/auth-components";
import {rbacActions} from "../../config/rbac/actions.ts";

export const ProductsLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.ListProducts) ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes(rbacActions.GetProduct) ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/products'/>
                    )
                }
            />
        </Routes>
    );
};
